import { JobPreferencesIcon } from 'pages/candidateOfferList/img';
import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import { ContentGuard } from 'shared/components';
import { APP_ROUTES } from 'shared/constants';

import OfferAdditionalAction from './OfferAdditionalAction';

export default function NavigateActionUpdatePreferences() {
    const { t } = useTranslation('candidateOffers');
    const navigate = useNavigate();
    const { search } = useLocation();

    const handleClick = useCallback(() => {
        navigate({
            pathname: APP_ROUTES.preferences,
            search
        });
    }, [ navigate, search ]);

    return (
        <ContentGuard feature="CandidatesJobPreferences">
            <OfferAdditionalAction
                icon={ <JobPreferencesIcon /> }
                iconColor="#D01C53"
                text={ t('additionalActions.updatePreferences') }
                description={ t('additionalActions.updatePreferencesDescription') }
                onClick={ handleClick }
            />
        </ContentGuard>
    );
}
